module.exports = __webpack_public_path__ + "static/img/客户案例banner.968b75f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ds-img/客户案例banner.png
// module id = +WoJ
// module chunks = 0